import React, { useState, useEffect } from 'react';
import { getProxiedCloudinaryUrl } from '../utils/cloudinaryProxy';
import { getCurrencySymbol } from '../utils/config';
import './MenuItem.css';

const MenuItem = ({ item, onOpenModal }) => {
  const [currencySymbol, setCurrencySymbol] = useState('RM');

  useEffect(() => {
    const loadCurrency = async () => {
      const symbol = await getCurrencySymbol();
      setCurrencySymbol(symbol);
    };
    loadCurrency();
  }, []);

  const handleClick = () => {
    onOpenModal(item);
  };

  const rawImageUrl = item.IMAGE_URL || item.image_url || '../img/dish.png';
  const imageUrl = getProxiedCloudinaryUrl(rawImageUrl);
  const itemName = item.NAME || item.name;
  const itemCode = item.ITEM_CODE || item.code || '';
  const description = item.DESCRIPTION || item.description || '';
  const price = item.BASE_PRICE || item.price || 0;

  return (
    <div className="menu-item-card" onClick={handleClick}>
      <div className="menu-item-image-container">
        <div
          className="menu-item-image"
          style={{
            backgroundImage: `url('${imageUrl}')`
          }}
        ></div>
      </div>
      <div className="menu-item-info">
        <div className="menu-item-header">
          <div className="menu-item-name">{itemName}</div>
          <div className="menu-item-price">{currencySymbol}{parseFloat(price).toFixed(2)}</div>
        </div>
        {itemCode && <div className="menu-item-code">Code: {itemCode}</div>}
        {description && <div className="menu-item-description">{description}</div>}
      </div>
    </div>
  );
};

export default MenuItem;